import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  deleteBuyOrderOrganization,
  deleteBuyOrderRelation,
  resetBuyOrderStore,
} from './buy-order-edit-redux';

export const useDeleteBuyOrderRelation = (id: string, relationId?: string) => {
  const dispatch = useDispatch();
  const handleRemoveRelation = useCallback(() => {
    if (relationId) {
      dispatch(deleteBuyOrderRelation({ id, relationId }));
    }
  }, [dispatch, id, relationId]);

  return {
    handleRemoveRelation,
  };
};

export const useDeleteBuyOrderOrganization = (
  id: string,
  organizationId?: string,
) => {
  const dispatch = useDispatch();
  const handleRemoveOrganization = useCallback(() => {
    if (organizationId) {
      dispatch(deleteBuyOrderOrganization({ id, organizationId }));
    }
  }, [dispatch, id, organizationId]);

  return {
    handleRemoveOrganization,
  };
};

export const useDeleteBuyOrderStore = (orderId: string) => {
  const dispatch = useDispatch();

  const resetBuyOrder = useCallback(() => {
    dispatch(resetBuyOrderStore({ id: orderId }));
  }, [dispatch, orderId]);

  return {
    resetBuyOrder,
  };
};
